import React, { useEffect, useState } from 'react';
import { Alert, Snackbar } from '@mui/material';

function AlertNotification({ alertType, message, open, onClose }) {
  const [showSnackbar, setShowSnackbar] = useState(false);

  useEffect(() => {
    if (open) {
      setShowSnackbar(true);
    }
  }, [open]);

  const handleClose = (event, reason) => {
    if (reason === 'clickaway') return;
    setShowSnackbar(false);
    onClose(); // Notify parent to reset the alert state
  };

  return (
    <Snackbar
      open={showSnackbar}
      autoHideDuration={6000}
      onClose={handleClose}
      anchorOrigin={{ vertical: 'top', horizontal: 'center' }}
      sx={{
        maxWidth: 'calc(100vw - 32px)'
      }}
    >
      <Alert
        variant="filled"
        onClose={handleClose}
        severity={alertType}
        sx={{
          width: 'fit-content',
          maxWidth: '100%',
          alignItems: 'center',
          '& .MuiAlert-message': {
            whiteSpace: 'pre-line',
            overflowWrap: 'anywhere',
            wordBreak: 'break-word',
            padding: 0,
            margin: 0
          },
          '& .MuiAlert-action': {
            alignItems: 'flex-start'
          }
        }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default AlertNotification;
